import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PlanCompensatorioComponent } from './plan-compensatorio.component';
import { GuardarCompensacionComponent } from './guardar-compensaciones/guardar-compensaciones.component';
import { InscripcionCompensacionComponent } from './inscripcion-compensacion/inscripcion-compensacion.component';
import { ListaCompensacionDependenciaComponent } from './lista-compensacion-dependencia/lista-compensacion-dependencia.component';
import { SolicitudAjusteCompensacionComponent } from './solicitud-ajuste-compensacion/solicitud-ajuste-compensacion.component';
import { ListaAjusteDependenciaComponent } from './lista-ajuste-dependencia/lista-ajuste-dependencia.component';
import { AuthGuard } from 'src/app/shared/guards/authGuard/auth.guard';


const routes: Routes = [
    { path: '', component: PlanCompensatorioComponent },
    { path: 'guardar-compensacion', component: GuardarCompensacionComponent, canActivate: [AuthGuard] },
    { path: 'inscripcion-compensacion', component: InscripcionCompensacionComponent, canActivate: [AuthGuard] },
    { path: 'lista-compensacion-dependencia', component: ListaCompensacionDependenciaComponent, canActivate: [AuthGuard] },
    { path: 'solicitud-ajuste-compensacion', component: SolicitudAjusteCompensacionComponent, canActivate: [AuthGuard] },
    { path: 'lista-ajuste-dependencia', component: ListaAjusteDependenciaComponent, canActivate: [AuthGuard] }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class PlanCompensatorioRouting { }
